<div container>
  <div class="t1d-stories">
    <h2>Real people, real reasons to screen</h2>
    <p class="mb-4">Waiting to screen - either because you didn't know you could or because it wasn't a priority - can have a major impact on your health.</p>
    <div video-carousel [videoCarouselData]="videoData" [transcript]="true"></div>
  </div>
</div>
